import React from 'react';

const Education = props => (
  <section id="education">
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="education__heading_wrapper">
            <h3 className="education__desc">Education</h3>
          </div>
          <div className="clearfix" />
          <div className="item">
            <h4>
              Bachelor of Science - Electrical Engineering with Computer
              Engineering Option
            </h4>
            <h5 className="education__short">Queen's University - Canada</h5>
            <h5>Class of 2001 - Graduated with First Class Honours</h5>
          </div>{' '}
          {/* item */}
        </div>{' '}
        {/* col-md-8 */}
      </div>{' '}
      {/* row end */}
    </div>{' '}
    {/* container */}
  </section>
);

export default Education;
